module.exports = __webpack_public_path__ + "static/media/  (167).68ed7321.jpg";